import { styled, theme } from "@theme/stitches.config"
import { NewsLetterSignUpWrapper } from "@components/NewsletterSignUp/styles"

export const UspsWrapper = styled("div", {
    [`& + ${NewsLetterSignUpWrapper}`]: {
        paddingTop: "0 !important"
    }
})

export const ContentWrapper = styled("div", {
    maxWidth: 710,
    width: "66.6667%",
    flex: "0 0 66.6667",
    "& button, a": {
        mt: 16
    },
    "& h1": {
        fontSizePxToRem: 60,
        lineHeight: 1,
        "@mdDown": {
            fontSizePxToRem: 40
        }
    },
    pr: 40,
    "@mdDown": {
        maxWidth: "100%",
        width: "100%",
        flex: "0 0 100"
    }
})

export const Container = styled("div", {
    width: 1240,
    maxWidth: "calc(100% - 200px)",
    mx: "auto",
    mt: 144,
    mb: 120,
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "@lgDown": {
        maxWidth: "calc(100% - 100px)"
    },
    "@mdDown": {
        mt: 60,
        maxWidth: "calc(100% - 40px)",
        mb: 60
    }
})

export const InnerWrapper = styled("div", {
    minWidth: 200,
    width: "33.3333%",
    flex: "0 0 33.3333",
    "& div:not(:last-child)": {
        mb: 60
    },
    "& h4": {
        color: theme.colors.R500
    },
    "& h6": {
        fontWeight: theme.fontWeights.regular
    },
    "@mdDown": {
        mt: 60,
        width: "100%",
        flexBasis: "100%"
    }
})

export const StyledH4 = styled("h4", {
    color: "white !important",
    mb: 60
})

export const ImageWrapper = styled("div", {
    width: "100%",
    height: "auto",
    "& img, & .gatsby-image-wrapper, * .gatsby-image-wrapper img": {
        display: "block",
        width: "100%",
        height: "100%",
        objectFit: "contain !important"
    }
})
